<template>
  <div v-title data-title="分销订单" class="mobile">
    <scroller
      :on-refresh="refresh"
      :on-infinite="infinite"
      style="padding-top: 00px;"
      ref="myScroller"
    >
      <section class="container">
        <div
          class="neworder-list"
          @click="OrderDetail(model.Guid)"
          v-for=" (model,$index) in orderlist"
          :key="$index"
        >
          <div class="flex">
            <p class="name">{{model.ProductName}}</p>
            <div class="pro-price">
              <p style="color:red">￥{{model.TotalSalePrice}}</p>
            </div>
          </div>
          <div class="flex">
            <p>
              <label style="width:80px">推广奖励</label>
              <span style="color:orange">￥{{model.Commission}}</span>
            </p>
            <div>
              <span v-if="model.ComboType==9&&model.OrderState==40" class="fr">待发货</span>
              <span v-else>{{model.OrderState|filterdictbyid(14)}}</span>
            </div>
          </div>
          <div class="flex">
            <p>
              <label style="width:80px">{{model.ContactName}}</label>
              {{model.ContactPhone |filterphone()}}
            </p>
          </div>
        </div>
      </section>
    </scroller>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import { Dialog } from "we-vue";

export default {
  name: "disorder",
  data: function() {
    return {
      currenttab: 0,
      borwser: this.GLOBAL.borwser,
      LoginType: -1,
      FirstInit: true, //首次加载（加载分页防止重复请求）
      popupVisible4: false,
      popupVisible3: false,
      popupVisible5: false,
      logourl: thumb,
      Keyword: "",
      OrderType: null,
      ComboTypes: [],
      formset: [],
      PageSize: 5,
      PageNum: 1,
      TotalCount: -1,
      orderlist: [],
      SelectAll: [
        {
          label: "全部筛选",
          value: "0"
        }
      ],
      RecommendSort: [
        // {
        //   label: "全部",
        //   value: null
        // },
        {
          label: "我的订单",
          value: 1
        },
        {
          label: "我的分销订单",
          value: 2
        }
      ],

      SelectAllItems: [],
      SelectAllComboTypes: [],
      SelectAllUseTypes: [],
      checkedItems: [],
      orderStateList: [],
      useTypeList: [],
      useTypes: [],
      combotypeList: []
    };
  },
  computed: {
    filterResult() {
      return this.defaultResult.filter(value =>
        new RegExp(this.value, "i").test(value)
      );
    }
  },
  created: function() {
    var url = window.location.href;
    var loginType = this.GetRequest(url)["logintype"];
    if (loginType == "dis") {
      localStorage.setItem("loginType", 4);
    }

    var type = this.GetRequest(url)["ordertype"];
    if (type != undefined && type != null && type.length > 0) {
      this.OrderType = type;
    } else {
      this.OrderType = 1;
    }

    var state = this.GetRequest(url)["orderstate"];
    if (state != undefined && state != null && state.length > 0) {
      this.currenttab = state;
      debugger;
      switch (state) {
        case "1":
          this.checkedItems.push(20);
          break;
        case "2":
          this.checkedItems.push(40);
          break;
        case "3":
          this.checkedItems.push(60);
          break;
        case "5":
          this.checkedItems.push(80);
          this.checkedItems.push(85);
          this.checkedItems.push(89);
          break;
      }
    }

    var useType = this.GetRequest(url)["usetype"];
    if (useType != undefined && useType != null && useType.length >= 0) {
      this.tabchange(useType);
    }
    this.InitOrder();
    this.InintChecklist();
  },
  methods: {
    urgentNotice: function(guid) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tborder/urgentnotice", {
          params: {
            orderGuid: guid
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            Toast.success("提醒发货成功");
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    refound: function(guid) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tborder/applyrefound", {
          params: {
            OrderGuid: guid
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            Toast.success("申请退款成功");
            this.$router.push("/app/order");
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    applyrefound: function(guid) {
      this.$router.push({
        path: "/page/applyrefound",
        query: {
          orderguid: guid
        }
      });
    },
    confirmReceipt: function(guid) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tborder/confirmreceipt", {
          params: {
            orderGuid: guid
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            Toast.success("确认收货成功");
            this.InitOrder(0);
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    viewLogistics: function(guid) {
      this.$router.push({
        path: "/page/viewlogistics",
        query: {
          orderguid: guid
        }
      });
    },
    pay: function(guid) {
      this.$router.push({
        path: "/page/orderdetail",
        query: {
          OrderGuid: guid,
          type: "pay"
        }
      });
    },
    tabchange: function(tab) {
      this.currenttab = tab;
      this.checkedItems = [];
      if (tab == 0) {
        this.OrderType = 1;
      } else if (tab == 1) {
        this.OrderType = 1;
        this.checkedItems.push(20);
      } else if (tab == 2) {
        this.OrderType = 1;
        this.checkedItems.push(40);
      } else if (tab == 3) {
        this.OrderType = 1;
        this.checkedItems.push(60);
      } else if (tab == 4) {
        this.OrderType = 2;
      } else if (tab == 5) {
        this.OrderType = 1;
        this.checkedItems.push(80);
        this.checkedItems.push(85);
        this.checkedItems.push(89);
      }
      this.onSearch();
    },

    InintChecklist: function() {
      this.orderStateList = Vue.filter("filterdictbychecklist")(14);
      this.combotypeList = Vue.filter("filterdictbychecklist")(44);
      this.useTypeList = Vue.filter("filterdictbychecklist")(60);
    },

    onShow() {
      console.log("shown");
    },
    onHide() {
      console.log("hidden");
    },
    onQueryShow() {
      console.log("onQueryShow");
    },
    onQueryHide() {
      console.log("onQueryHide");
    },
    InitOrder: function(type) {
      var data = {
        Keyword: this.Keyword,
        OrderType: this.OrderType,
        ComboTypes: this.ComboTypes,
        OrderStates: [30, 40, 60, 70, 80, 85, 89, 97],
        UseTypes: this.useTypes,
        PageSize: this.PageSize,
        PageNum: this.PageNum
      };
      this.$http
        .post(this.GLOBAL.BASE_URL + "api/tborder/getdisorderpager", data, {
          emulateJSON: true
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.LoginType = rep.Data.LoginType;
            this.formset = rep.Data;
            this.TotalCount = this.formset.Page.Total;
            if (type != 1) {
              this.orderlist = [];
              this.formset.List.forEach(element => {
                if (element.ProductName.length >= 27) {
                  element.ProductName =
                    element.ProductName.substring(0, 27) + "...";
                }
                this.orderlist.push(element);
              });
            } else {
              this.formset.List.forEach(element => {
                if (element.ProductName.length >= 27) {
                  element.ProductName =
                    element.ProductName.substring(0, 27) + "...";
                }
                this.orderlist.push(element);
              });
            }
          } else {
            Toast.fail(rep.Message);
          }
          this.$store.commit("hideLoading");
        });
    },
    onSearch(val) {
      this.PageNum = 1;
      this.$store.commit("showLoading");
      // 自定义搜索处理
      this.InitOrder(0);
    },
    onCancel(val) {
      // 自定义取消事件处理
    },

    //订单详情
    OrderDetail: function(guid) {
      this.$router.push({
        path: "/page/orderdetaildisview",
        query: {
          OrderGuid: guid
        }
      });
    },

    refresh: function(done) {
      //下拉
      var self = this;
      setTimeout(function() {
        self.PageNum = 1;
        self.InitOrder(0);
        done();
      }, 1500);
    },
    infinite: function(done) {
      var self = this;
      setTimeout(function() {
        if (self.FirstInit) {
          self.FirstInit = false;
          if (self.TotalCount == self.formset.List.length) {
            self.$refs.myScroller.finishInfinite(true);
            return;
          }
        }

        self.PageNum += 1;
        self.InitOrder(1);
        done();
        if (self.formset.List.length == 0) {
          self.$refs.myScroller.finishInfinite(true);
          return;
        }
      }, 2000);
    },
    SortChange(val) {
      this.popupVisible4 = false;
      this.PageNum = 1;
      // 自定义搜索处理
      this.InitOrder(0);
    },

    btnClose: function() {
      this.popupVisible3 = false;
      this.popupVisible4 = false;
      this.popupVisible5 = false;
    },
    btnSearch: function() {
      this.PageNum = 1;
      this.InitOrder(0);
      this.popupVisible3 = false;
      this.popupVisible4 = false;
      this.popupVisible5 = false;
    }
  },
  watch: {
    //选择所有订单桩体查询条件
    SelectAllItems: function(val) {
      this.checkedItems = [];
      if (val == "0") {
        this.orderStateList.forEach(element => {
          this.checkedItems.push(element.value);
        });
      }
    },
    //选择所有套餐类型
    SelectAllComboTypes: function(val) {
      this.ComboTypes = [];
      if (val == "0") {
        this.combotypeList.forEach(element => {
          this.ComboTypes.push(element.value);
        });
      }
    },
    //选择所有使用类型
    SelectAllUseTypes: function(val) {
      this.useTypes = [];
      if (val == "0") {
        this.useTypeList.forEach(element => {
          this.useTypes.push(element.value);
        });
      }
    }
  }
};
</script>




<style>
.combo-price {
  color: red;
  font-size: 1.17rem;
}
.combo-qi {
  font-size: 0.75rem;
  color: #999;
}
.wv-button {
  float: right;
  margin-right: 5%;
}
.weui-form-preview__hd {
  line-height: 1.5em;
  padding: 8px 15px;
}

.weui-media-box__date {
  float: right;
}

.weui-form-preview__btns {
  width: 100%;
  text-align: right;
  padding-right: 20px;
  padding-bottom: 5px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: #3cc51f;
  display: block;
  flex: 1;
  position: relative;
}

.weui-media-box__content {
  text-align: right;
  float: right;
  width: 100%;
  font-size: 14px;
}

.fontsf {
  font-size: 14px;
  color: #000;
}

.fontsn {
  font-size: 14px;
}

.weui-form-preview__border {
  height: 10px;
  background-color: #efeff4;
}

.weui-search-bar {
  z-index: 9999;
}

.popup {
  z-index: 9998;
  position: relative;
  background-color: #fff;
  line-height: 2em;
  padding-top: 50px;
  font-size: 1.5rem;
}

.search_left_three {
  width: 33%;
  text-align: center;
  font-size: 0.9em;
  float: left;
  background-color: #fff;
}

.weui-cells {
  font-size: 14px;
  margin-top: 0px;
}
.weui-zdycolors {
  color: #999;
}
.weui-spaces {
  height: 10px;
  background-color: #efeff4;
}
.red .weui-cell__ft {
  color: red;
}
.needtomargin-top-wx {
  padding-top: 0px;
}
.needtomargin-top-common {
  padding-top: 0px;
}
.neworder-list {
  margin-bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/disorder/disorder.vue